import { ProgressSpinner } from "primereact/progressspinner";

export const SpinnerPage = () => {
  return (
    <div className="flex flex-column h-screen w-full align-items-center justify-content-center surface-ground">
      <ProgressSpinner
        style={{ width: "50px", height: "50px" }}
        strokeWidth="4"
        animationDuration=".5s"
      />
      <span className="text-color-secondary font-medium mt-3 fadein animation-duration-1000 animation-iteration-infinite">
        Cargando...
      </span>
    </div>
  );
};
